import React, {useState, useEffect} from 'react';
import { useHistory, useParams }    from 'react-router-dom';
import { useSelector }              from 'react-redux';
import { 
  TextField,
  Button,
  CircularProgress }                from '@material-ui/core';
import { makeStyles }               from '@material-ui/core/styles';
import Products                     from '../../services/db/Products';
import { useFirestore }             from 'react-redux-firebase';
import ProductInfo                  from '../../components/ProductInfo';
import { deleteStorage } from '../../app/redux/backendStorage';

const useStyles = makeStyles((theme) => ({
  loading: {
    display         : "flex",
    marginTop       :  "100px",
    justifyContent  : "center"
  },
  hText:  {
    paddingTop      : theme.spacing(2),
    margin          : theme.spacing(1),
  },
  rodapeComentary:{fontSize: "12px", color: "rgb(111 111 111)", margin:"2px auto"},
}));

function printFloat(f){
  return parseFloat(f).toFixed(2).replace(".", ",")
}


export default function BuyIndividualProduct() {
  const db          = useFirestore();
  const params      = useParams();
  const history     = useHistory();
  const classes     = useStyles();

  const associated    = useSelector((state) => state.backend.associated);

  let [loading, setLoading]   = useState(true);
  let [product, setProduct]   = useState({});
  let [quantity, setQuantity] = useState(0);
  let [alreadyPurchased, 
    setAlreadyPurchased]      = useState(false);
  
  let {id} = params
  
  useEffect( ()=>{
    const fetchData = async () =>{
      const productFetched  = await Products.find(db, id);

      // Se o produto ja tiver sido comprado
      const purchaseInfo = associated.individualPurchases.alreadyPurchased(productFetched.docRef.id);
      if(purchaseInfo){
        setAlreadyPurchased(true)
        setQuantity(purchaseInfo.quantity)
      }

      setProduct(productFetched);
      setLoading(false);
    }

    fetchData();
  }, [db, id, associated]);

  async function handleQuero(){
    if(quantity <= 0){alert("Por favor selecionar mais de 1 item");return}
    await associated.individualPurchases.updatePurchase(product.docRef.id, quantity);
    deleteStorage("associated/"+associated.docRef.id)
    history.push("/associated/avulsos")
  }

  return loading ? <div className={classes.loading}><CircularProgress /></div> : ( 
    <div className={classes.hText}>
      <ProductInfo product={product} />

      <TextField 
        id="standard-basic" 
        inputProps={{ min: 0 }} 
        label="Quantidade" 
        type="number" 
        value={quantity}
        onChange={(ev)=>{setQuantity(ev.target.value)}}
        style={{marginTop: "10px"}}
        fullWidth={true} 
      />

      <div style={{display:"flex", flexDirection:"column",margin:"10px 20px", paddingTop:"50px", justifyContent:"center"}}>
        <div style={{display:"flex", justifyContent:"space-between"}}>
          <div>Total:</div>
          <div>R$ {printFloat(quantity * product.props.price)}</div>
          <Button variant="contained" color="primary" size="medium" style={{fontSize: "12px"}} onClick={handleQuero}>
            {alreadyPurchased ? "Atualizar entrega" : "Quero"}
          </Button>
        </div>
        <div className={classes.rodapeComentary}>
          Itens individuais serão entregues na próxima entrega
        </div>
      </div>
    </div>
  );
}
